import { Text } from '@hopin-team/ui-text';
import { string } from 'prop-types';
import React from 'react';

import { Styles } from './event-social-styles';

const Facebook = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
  >
    <path
      d="M2.32424 14V7.73828H0V5.25H2.32424V3.28945C2.32424 1.15938 3.76667 0 5.87273 0C6.88182 0 7.74849 0.0683594 8 0.0984375V2.32422H6.53939C5.39394 2.32422 5.17273 2.81641 5.17273 3.53555V5.25H7.75758L7.40303 7.73828H5.17273V14"
      fill="#757a8a"
    ></path>
  </svg>
);

const Linkedin = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M4.99998 6.33333V13C4.99998 13.0884 4.96486 13.1732 4.90235 13.2357C4.83984 13.2982 4.75505 13.3333 4.66665 13.3333H2.99998C2.91157 13.3333 2.82679 13.2982 2.76428 13.2357C2.70177 13.1732 2.66665 13.0884 2.66665 13V6.33333C2.66665 6.24493 2.70177 6.16014 2.76428 6.09763C2.82679 6.03512 2.91157 6 2.99998 6H4.66665C4.75505 6 4.83984 6.03512 4.90235 6.09763C4.96486 6.16014 4.99998 6.24493 4.99998 6.33333ZM14 8.94C14.0111 8.2394 13.7826 7.55602 13.3521 7.00313C12.9217 6.45024 12.3152 6.06102 11.6333 5.9C11.1693 5.80009 10.6881 5.81271 10.23 5.93681C9.77187 6.06091 9.35011 6.29288 8.99998 6.61333V6.33333C8.99998 6.24493 8.96486 6.16014 8.90235 6.09763C8.83984 6.03512 8.75505 6 8.66665 6H6.99998C6.91157 6 6.82679 6.03512 6.76428 6.09763C6.70177 6.16014 6.66665 6.24493 6.66665 6.33333V13C6.66665 13.0884 6.70177 13.1732 6.76428 13.2357C6.82679 13.2982 6.91157 13.3333 6.99998 13.3333H8.66665C8.75505 13.3333 8.83984 13.2982 8.90235 13.2357C8.96486 13.1732 8.99998 13.0884 8.99998 13V9.24C8.992 8.91565 9.09857 8.59886 9.30095 8.34526C9.50334 8.09167 9.7886 7.9175 10.1066 7.85333C10.2997 7.82 10.4978 7.82964 10.6867 7.88155C10.8756 7.93346 11.0508 8.02637 11.1997 8.15367C11.3487 8.28097 11.4677 8.43953 11.5484 8.61808C11.6291 8.79662 11.6695 8.99075 11.6666 9.18667V13C11.6666 13.0884 11.7018 13.1732 11.7643 13.2357C11.8268 13.2982 11.9116 13.3333 12 13.3333H13.6666C13.7551 13.3333 13.8398 13.2982 13.9023 13.2357C13.9649 13.1732 14 13.0884 14 13V8.94ZM3.66665 2C3.40294 2 3.14515 2.0782 2.92589 2.22471C2.70662 2.37122 2.53572 2.57945 2.43481 2.82309C2.33389 3.06672 2.30749 3.33481 2.35893 3.59345C2.41038 3.8521 2.53737 4.08967 2.72384 4.27614C2.91031 4.46261 3.14789 4.5896 3.40653 4.64105C3.66517 4.69249 3.93326 4.66609 4.17689 4.56517C4.42053 4.46426 4.62876 4.29336 4.77527 4.07409C4.92178 3.85483 4.99998 3.59704 4.99998 3.33333C4.99998 2.97971 4.8595 2.64057 4.60946 2.39052C4.35941 2.14048 4.02027 2 3.66665 2Z"
      fill="#757a8a"
    ></path>
  </svg>
);

const Twitter = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6667 2.3C13.3221 2.75937 12.9056 3.16008 12.4333 3.48667C12.4333 3.60667 12.4333 3.72667 12.4333 3.85333C12.4352 4.93214 12.2224 6.00055 11.8074 6.99633C11.3924 7.99212 10.7834 8.8954 10.016 9.65356C9.24848 10.4117 8.33784 11.0096 7.33706 11.4125C6.33628 11.8153 5.26537 12.015 4.18666 12C2.92694 12.0042 1.68336 11.7167 0.553325 11.16C0.523512 11.147 0.498158 11.1255 0.480389 11.0983C0.46262 11.071 0.453212 11.0392 0.453325 11.0067V10.9333C0.453325 10.8874 0.471587 10.8433 0.504093 10.8108C0.5366 10.7783 0.580688 10.76 0.626658 10.76C1.86493 10.7192 3.05902 10.2901 4.03999 9.53333C3.4908 9.52228 2.95591 9.35618 2.49706 9.05421C2.0382 8.75224 1.67406 8.32669 1.44666 7.82667C1.43513 7.79926 1.43085 7.76935 1.43422 7.7398C1.43759 7.71026 1.44851 7.68209 1.46592 7.65798C1.48333 7.63388 1.50664 7.61466 1.53363 7.60217C1.56061 7.58968 1.59035 7.58434 1.61999 7.58667C1.96063 7.62089 2.30467 7.5892 2.63333 7.49333C2.03031 7.36822 1.48262 7.0548 1.06924 6.59829C0.655865 6.14178 0.398171 5.56577 0.333325 4.95333C0.331 4.92369 0.336339 4.89395 0.348828 4.86697C0.361318 4.83998 0.380539 4.81667 0.404642 4.79926C0.428746 4.78185 0.456923 4.77094 0.486464 4.76756C0.516005 4.76419 0.545917 4.76847 0.573325 4.78C0.905356 4.92644 1.26378 5.00357 1.62666 5.00667C1.09947 4.66081 0.701689 4.15008 0.495444 3.55427C0.289199 2.95845 0.286109 2.31109 0.486658 1.71333C0.507585 1.65461 0.543401 1.60234 0.590599 1.56162C0.637796 1.52089 0.694759 1.49313 0.75591 1.48103C0.817062 1.46894 0.880306 1.47293 0.939452 1.49261C0.998598 1.5123 1.05162 1.547 1.09333 1.59333C2.55631 3.14965 4.56648 4.07705 6.69999 4.18C6.64534 3.96204 6.61846 3.73804 6.61999 3.51333C6.62975 2.93723 6.81051 2.37702 7.1393 1.90386C7.4681 1.43071 7.93011 1.06594 8.46665 0.855899C9.00318 0.645856 9.59004 0.600014 10.1527 0.724193C10.7153 0.848372 11.2284 1.13697 11.6267 1.55333C12.1819 1.4476 12.7187 1.26118 13.22 0.999999C13.238 0.988768 13.2588 0.982814 13.28 0.982814C13.3012 0.982814 13.322 0.988768 13.34 0.999999C13.3512 1.018 13.3572 1.03878 13.3572 1.06C13.3572 1.08121 13.3512 1.102 13.34 1.12C13.0972 1.67573 12.687 2.14185 12.1667 2.45333C12.6223 2.40052 13.07 2.29308 13.5 2.13333C13.5177 2.12129 13.5386 2.11486 13.56 2.11486C13.5814 2.11486 13.6023 2.12129 13.62 2.13333C13.635 2.14018 13.6483 2.15022 13.659 2.16274C13.6697 2.17527 13.6775 2.18997 13.682 2.20584C13.6864 2.22171 13.6874 2.23835 13.6847 2.25461C13.6821 2.27087 13.6759 2.28636 13.6667 2.3Z"
      fill="#757a8a"
    ></path>
  </svg>
);

const SMS = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8081 0.699219H4.80811C2.59897 0.699219 0.808105 2.49008 0.808105 4.69922V20.1992C0.808105 20.4754 1.03196 20.6992 1.30811 20.6992C1.44022 20.6985 1.56643 20.6444 1.65811 20.5492L4.65811 17.5492C5.23243 16.99 6.00666 16.6839 6.80811 16.6992H16.8081C19.0172 16.6992 20.8081 14.9084 20.8081 12.6992V4.69922C20.8081 2.49008 19.0172 0.699219 16.8081 0.699219ZM6.80811 14.6992C5.48112 14.6968 4.20761 15.2221 3.26811 16.1592L2.80811 16.5792V4.69922C2.80811 3.59465 3.70354 2.69922 4.80811 2.69922H16.8081C17.9127 2.69922 18.8081 3.59465 18.8081 4.69922V12.6992C18.8081 13.8038 17.9127 14.6992 16.8081 14.6992H6.80811ZM7.30811 9.69922H6.30811C6.03196 9.69922 5.80811 9.47536 5.80811 9.19922V8.19922C5.80811 7.92308 6.03196 7.69922 6.30811 7.69922H7.30811C7.58425 7.69922 7.80811 7.92308 7.80811 8.19922V9.19922C7.80811 9.47536 7.58425 9.69922 7.30811 9.69922ZM10.3081 9.69922H11.3081C11.5842 9.69922 11.8081 9.47536 11.8081 9.19922V8.19922C11.8081 7.92308 11.5842 7.69922 11.3081 7.69922H10.3081C10.032 7.69922 9.80811 7.92308 9.80811 8.19922V9.19922C9.80811 9.47536 10.032 9.69922 10.3081 9.69922ZM15.3081 9.69922H14.3081C14.032 9.69922 13.8081 9.47536 13.8081 9.19922V8.19922C13.8081 7.92308 14.032 7.69922 14.3081 7.69922H15.3081C15.5842 7.69922 15.8081 7.92308 15.8081 8.19922V9.19922C15.8081 9.47536 15.5842 9.69922 15.3081 9.69922Z"
      fill="#757A8A"
    ></path>
  </svg>
);

const WhatsApp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"
      fill="#757A8A"
    ></path>
  </svg>
);

const EventSocial = ({
  facebookShareUrl,
  twitterShareUrl,
  smsShareUrl,
  linkedinShareUrl,
  whatsappShareUrl,
}) => {
  return (
    <>
      <Text pattern="labelFour" element="p" my={3}>
        SHARE ON
      </Text>
      <Styles.Flex>
        <a href={linkedinShareUrl}>
          <Styles.Icon>
            <Linkedin />
          </Styles.Icon>
        </a>
        <a href={twitterShareUrl}>
          <Styles.Icon>
            <Twitter />
          </Styles.Icon>
        </a>
        <a href={facebookShareUrl}>
          <Styles.Icon>
            <Facebook />
          </Styles.Icon>
        </a>
        <a href={smsShareUrl}>
          <Styles.Icon>
            <SMS />
          </Styles.Icon>
        </a>
        <a href={whatsappShareUrl}>
          <Styles.Icon>
            <WhatsApp />
          </Styles.Icon>
        </a>
      </Styles.Flex>
    </>
  );
};

EventSocial.propTypes = {
  facebookShareUrl: string,
  twitterShareUrl: string,
  smsShareUrl: string,
  linkedinShareUrl: string,
  whatsappShareUrl: string,
};

export default EventSocial;
